export default "__VITE_ASSET__ayOw4haj__"